import {Routes, RouterModule} from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { ChangePasswordComponent } from '../authentication/change-password/change-password.component';
import { SessionExpiredComponent } from '../authentication/session-expired/session-expired.component';
import { NotAuthorizedComponent } from '../authentication/not-authorized/not-authorized.component';
import { NotFoundComponent } from '../authentication/not-found/not-found.component';
import { LoginComponent } from '../authentication/login/login.component';
import { AdminLayoutComponent } from '../layouts/layout.component';
import { AuthorizationGuard } from '../nucleo/guards/auth-guard';

export const routes: Routes = [
  {
  path: '',
  component: AdminLayoutComponent, children: [
    {
      path: '', redirectTo: 'home',  pathMatch: 'full'
    }, 
    {
      path: 'home', loadChildren: './home/home.module#HomeModule'
    },    
  ], canActivate: [AuthorizationGuard]
},
{
  path: 'login',
  component: LoginComponent
},
{
  path: 'change-password',
  component: ChangePasswordComponent
},
{
  path: 'not-authorized',
  component: NotAuthorizedComponent
},
{
  path: 'not-found',
  component: NotFoundComponent
},
{
  path: 'session-expired',
  component: SessionExpiredComponent
},
{
  path: '**',
  redirectTo: 'not-found'
}];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {
  // preloadingStrategy: PreloadAllModules,  // <- uncomment this line for disable lazy load
  useHash: true
});
